import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import getEarlyRequesterResult from './getEarlyRequesterResult';
import { ELIGIBLE_AFTER_RENEWAL_FILTERS, ELIGIBLE_AFTER_SWITCH_TO_MC_FILTERS
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'mark... Remove this comment to see the full error message
} from 'marketing-contacts-client/constants/Filters';
import { MARKETING_CONTACTS_RENEWAL, MARKETING_CONTACTS_SWITCH } from '../constants/EarlyRequesterNames';
const ENDPOINT = 'crm-search/search';
export const crmSearch = (filterGroups, earlyRequesterName = '', isDevPortal = false) => {
  const data = {
    portalId: PortalIdParser.get(),
    objectTypeId: 'CONTACT',
    count: 0,
    filterGroups: Array.isArray(filterGroups) ? filterGroups : [filterGroups]
  };

  // Dev portals will always return 403, instead return 0 and avoid sentry logging
  const isExpectedError = () => {
    if (isDevPortal) {
      return {
        total: 0
      };
    }
    return false;
  };
  const earlyRequest = getEarlyRequesterResult(earlyRequesterName, isExpectedError);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.post(ENDPOINT, {
    query: {
      clienttimeout: 7000
    },
    data
  })) : null;
  return earlyRequestWithRetry || http.post(ENDPOINT, {
    query: {
      clienttimeout: 7000
    },
    data
  });
};
export const fetchMarketingContactsOnMCRenewal = (isDevPortal = false) => {
  return crmSearch(ELIGIBLE_AFTER_RENEWAL_FILTERS, MARKETING_CONTACTS_RENEWAL, isDevPortal);
};
export const fetchMarketingContactsOnSwitchToMC = (isDevPortal = false) => {
  return crmSearch(ELIGIBLE_AFTER_SWITCH_TO_MC_FILTERS, MARKETING_CONTACTS_SWITCH, isDevPortal);
};